import { useState, useEffect } from 'react';
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import DateTimePicker from "../../../Component/dateTimePicker";
import moment from "moment";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import AdminTable from "../../../Component/adminTable";
import { statusActiveDeactiveDeleted, tbpSourceList } from "../../../Utils/dataConstant";
import { getSourceWiseUserCount } from '../cxoSlice';
import { showSnackbar, hideSnackbar } from '../../../store/slices/snackbarSlice';
const AllSourceLeadCount = () => {
    const dispatch: Function = useDispatch<AppDispatch>();
    const [allSourceLead, setAllSourceLead] = useState<any>([]);
    const [source, setSource] = useState<any>();
    const [status, setStatus] = useState<any>();
    const [startDate, setStartDate] = useState<any>(
        moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
    );
    const [endDate, setEndDate] = useState<any>(
        moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
    );

    const onchangeSource = (value: any) => {
        setSource(value);

    };
    const onchangeStatus = (value: any) => {
        setStatus(value);
    };

    const onchangeStartDate = (value: any) => {
        setStartDate(value);
    };
    const onchangeEndDate = (value: any) => {
        setEndDate(value);
    };
    const handleSubmit = (e: any) => {
        e.preventDefault();
        const postData = {
            startDate: startDate,
            endDate: endDate
        };
        if (source) {
            (postData as any)["source"] = `${source?._id}`;
        };
        if (status) {
            (postData as any)["status"] = status?._id;
        };
        dispatch(getSourceWiseUserCount({
            params: postData,
            callback: (res: any) => {
                setAllSourceLead(res?.data);
                dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                setTimeout(() => {
                    dispatch(hideSnackbar());
                }, 5000);
            },
            errorCallback: (error: any) => {
                console.error(error);
                dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
                setTimeout(() => {
                    dispatch(hideSnackbar());
                }, 5000);
            }
        }))
    };
    const validations = () => {
        let valid = false;
        if (startDate === "" || endDate === "") {
            valid = true;
        }
        return valid;
    };
    const renderTable = () => {
        return (
            <div className="mt-4">
                <AdminTable
                    tableData={allSourceLead?.Details ? allSourceLead?.Details : []}
                    pagename={"allSourceLead"}
                    tableHead={[
                        "S.N",
                        "RGISTRATION COUNT",
                        "PERCENTAGE",
                        "Source",
                    ]}
                />
            </div>
        );
    };
    return (
        <div className="panel-content">
            <div className="mb-4">
                <PageTitle name={"ALL SOURCE LEAD COUNT"} />
            </div>
            <div className="formDiv">
                <div className="bxshadow p-2 borderRadius mb-4 ">
                    <form onSubmit={handleSubmit}>
                        <div className="row ">
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Start Date"} isRequired />
                                <DateTimePicker
                                    setInputText={(value: any) => {
                                        onchangeStartDate(value);
                                    }}
                                    value={startDate}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"End Date"} isRequired />
                                <DateTimePicker
                                    setInputText={(value: any) => {
                                        onchangeEndDate(value);
                                    }}
                                    value={endDate}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Source"} />
                                <DropdownWithClear
                                    labelName={"Select Source"}
                                    setInputText={(value: any) => onchangeSource(value)}
                                    options={tbpSourceList}
                                    value={source}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Status"} />
                                <DropdownWithClear
                                    labelName={"Select Status"}
                                    setInputText={(value: any) => onchangeStatus(value)}
                                    options={statusActiveDeactiveDeleted}
                                    value={status}
                                />
                            </div>
                            <div className="d-flex justify-content-center mt-3">
                                <div className="col-2 pt-2">
                                    <Submitbtn name={"Submit"} disabled={validations()} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className='bxshadow p-2 borderRadius'>
                    {renderTable()}
                </div>
            </div>
        </div>
    );
}

export default AllSourceLeadCount;